import axios from 'axios';
import { deleteOrCancelMemberAction } from './DeleteOrCancelMemberSlice';

const deleteOrCancelMember = (token, id) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/family/invite/${id}`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.delete(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(deleteOrCancelMemberAction.deleteOrCancelMemberSuccess(result.data));
    } catch (e) {
      dispatch(deleteOrCancelMemberAction.deleteOrCancelMemberFailure(e.response?.data ?? e.message));
    }
  };
};

export default deleteOrCancelMember;